import './LogoAndText.pcss';
import React from 'react';
import monkeyLogo from 'assets/monkey-logo@2x.png';

export const LogoAndText = () => {
  return (
    <div className="logo-and-text">
      <img
        src={monkeyLogo}
        alt="MobileMonkey Logo"
        className="logo-and-text__logo-image"
      />

      <div className="logo-and-text__logo-name">MobileMonkey</div>
    </div>
  );
};
